import React, { Component } from 'react';
import {
    FormGroup, ControlLabel, FormControl
} from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
import { Authenticator } from 'services/AuthService.jsx'
import Button from 'elements/CustomButton/CustomButton.jsx';
import { Redirect } from 'react-router-dom'
import NotificationSystem from 'react-notification-system';
import { style } from "variables/Variables.jsx";

import Log from 'services/Log.jsx'



export default class PasswordReset extends Component {
  state = {
    redirectToReferrer: Authenticator.authenticated,
    _notificationSystem: null,
    email: "",
    token: ""
  };
  constructor(props) {
      super(props);
      this.handleNotification = this.handleNotification.bind(this);
  }
  componentDidMount() {
      this.setState({_notificationSystem: this.refs.notificationSystem});
  }
  askReset(e) {
    e.preventDefault();
    Log.debug("PWR Token: " + JSON.stringify(this.props.match.params.token));
    Authenticator.resetPassword(this.props.match.params.token, { password: this.state.password, passwordRepeat: this.state.passwordRepeat}, (response) => {
        Log.debug(JSON.stringify(response));
      if (response.success) {
        this.handleNotification({
            level: 'success',
            message: 'Your password has been reset'
        });
      } else {
          response.errors.forEach((error) => {
              this.handleNotification({
                  level: 'warning',
                  message: error
              });
          });
      }
    });
  }
  handleNotification(data) {
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-attention"></span>),
        message: (
            <div>
                {data.message}
            </div>
        ),
        level: data.level,
        position: 'tc',
        autoDismiss: 3,
        dismissible: false
    });
  }
  handleChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }
  render() {
    const { from } = { from: { pathname: '/' } };
    if (this.props.location && this.props.location.state) {
      this.from = this.props.location.state;
    }
    const { redirectToReferrer } = this.state;
    if (redirectToReferrer === true) {
      return (<Redirect to={from} />);
    } else {
      return (
        <form onSubmit={this.askReset.bind(this)}>
          <NotificationSystem ref="notificationSystem" style={style}/>
          <Card
              hidden={this.state.cardHidden}
              color="card-darkblue"
              title="Reset your password"
              content={
                  <div>
                      <FormGroup>
                          <ControlLabel>
                              Password
                          </ControlLabel>
                          <FormControl
                              placeholder="Enter password"
                              type="password"
                              name="password"
                              onChange={this.handleChange.bind(this)}
                          />
                          <ControlLabel>
                              Repeat Password
                          </ControlLabel>
                          <FormControl
                              placeholder="Confirm password"
                              type="password"
                              name="passwordRepeat"
                              onChange={this.handleChange.bind(this)}
                          />
                      </FormGroup>
                  </div>
              }
              legend={
                <Button bsStyle="info" type="submit" fill wd >
                    Reset password
                </Button>
              }
              ftTextCenter
          />
        </form>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/FormInputs/PasswordReset.jsx